import { render, staticRenderFns } from "./peopleForm.vue?vue&type=template&id=2f3d0694&scoped=true&"
import script from "./peopleForm.vue?vue&type=script&lang=js&"
export * from "./peopleForm.vue?vue&type=script&lang=js&"
import style0 from "./peopleForm.vue?vue&type=style&index=0&id=2f3d0694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d0694",
  null
  
)

export default component.exports